module.exports = __webpack_public_path__ + "img/svg/help.34787a5bba0a2f491d1d064af54ecc64.svg";